import { render, staticRenderFns } from "./PneuPrincipalLançamentos.vue?vue&type=template&id=3165740a&"
import script from "./PneuPrincipalLançamentos.vue?vue&type=script&lang=js&"
export * from "./PneuPrincipalLançamentos.vue?vue&type=script&lang=js&"
import style0 from "./PneuPrincipalLançamentos.vue?vue&type=style&index=0&id=3165740a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports